import React, { Component } from 'react'
import {Tab,Tabs,Grid,Cell,Card,CardTitle,CardActions,Button,CardMenu,IconButton, CardText} from 'react-mdl';
class projects extends Component {
    constructor(props) {
        super(props);
        this.state = {activeTab:0};
    }
    toggleCategories(){
        if(this.state.activeTab === 0)
        {
            return(
                    <div className="projects-grid">
                {/* Project 1 */}
                <Card shadow={5} style={{minWidth:'450',margin:'auto'}}>
                    <CardTitle style={{color:'black',height:'176px',background:'url(https://banner2.cleanpng.com/20180604/pol/kisspng-react-javascript-angularjs-ionic-atom-5b154be6709500.6532453515281223424611.jpg)center/cover'}}>TodoList</CardTitle>
                    <CardText>TodoList for all the tasks you want to do so whenever u complete u can delete and any mistake can update.</CardText>
                    <CardActions border>
                        <Button colored href="https://github.com/yamini465">Github</Button>
                        <Button colored href="https://yamini465.github.io/todolist/">Live Demo</Button>
                    </CardActions>
                    <CardMenu style={{color:'black'}}>
                        <IconButton name="share"></IconButton>
                    </CardMenu>
                </Card>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                 {/* Project 2 */}
                 <Card shadow={5} style={{minWidth:'450',margin:'auto'}}>
                 <CardTitle style={{color:'black',height:'176px',background:'url(https://banner2.cleanpng.com/20180604/pol/kisspng-react-javascript-angularjs-ionic-atom-5b154be6709500.6532453515281223424611.jpg)center/cover'}}>Covid Tracker</CardTitle>
                 <CardText>It gives overall data of all the people who are infected , recovered and caused a death due to COVID-19.</CardText>
                 <CardActions border>
                     <Button colored href="https://github.com/yamini465">Github</Button>
                     <Button colored href="https://yamini465.github.io/Covid-19Tracker/">Live Demo</Button>
                 </CardActions>
                 <CardMenu style={{color:'black'}}>
                     <IconButton name="share"></IconButton>
                 </CardMenu>
             </Card>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {/* Project 3 */}
              <Card shadow={5} style={{minWidth:'450',margin:'auto'}}>
              <CardTitle style={{color:'black',height:'176px',background:'url(https://banner2.cleanpng.com/20180604/pol/kisspng-react-javascript-angularjs-ionic-atom-5b154be6709500.6532453515281223424611.jpg)center/cover'}}>Movie Finder</CardTitle>
              <CardText>You can search any movie of all categories which you are interested in finding and can see all the related suggested movies.</CardText>
              <CardActions border>
                  <Button colored href="https://github.com/yamini465">Github</Button>
                  <Button colored href="https://yamini465.github.io/MovieFinder/">Live Demo</Button>
              </CardActions>
              <CardMenu style={{color:'black'}}>
                  <IconButton name="share"></IconButton>
              </CardMenu>
          </Card>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
           {/* Project 4 */}
           <Card shadow={5} style={{minWidth:'450',margin:'auto'}}>
              <CardTitle style={{color:'black',height:'176px',background:'url(https://banner2.cleanpng.com/20180604/pol/kisspng-react-javascript-angularjs-ionic-atom-5b154be6709500.6532453515281223424611.jpg)center/cover'}}>Chatbot</CardTitle>
              <CardText>A simple chatbot with few questions which you feel free to ask and it answers you immediately and learns from the experience.</CardText>
              <CardActions border>
                  <Button colored href="https://github.com/yamini465">Github</Button>
                  <Button colored href="https://yamini465.github.io/chatbot/">Live Demo</Button>
              </CardActions>
              <CardMenu style={{color:'black'}}>
                  <IconButton name="share"></IconButton>
              </CardMenu>
          </Card>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          
            )
        }
        else if(this.state.activeTab === 1)
        {
            return (
            <div><h1>Coming Soon......</h1></div>
            )
        }
        else if(this.state.activeTab === 2)
        {
            return(
            <div><h1>Coming Soon......</h1></div>
            )
        }
    }
    
   
    
    render() {
        return (
            <div className="category-tabs">
                <Tabs activeTab={this.state.activeTab} onChange={(tabId)=> this.setState({activeTab:tabId})} ripple>
                    <Tab>React</Tab>
                    <Tab>Node</Tab>
                    <Tab>MongoDB</Tab>
                </Tabs>
                <section className="projects-grid">
                    <Grid>
                        <Cell col={12}>
                            <div className="content">{this.toggleCategories()}</div>
                        </Cell>
                    </Grid>
                </section>
            </div>
            
        )
    }
}

export default projects
